app.controller('BrowseFilterController', ['$rootScope', '$scope', function ($rootScope, $scope) {

    const siteHelper = $rootScope.site_helper;

    const navigationIDs = $scope.navigation_ids;

    const filterModel = $scope.filter_model = $rootScope.factory.filter.getModel(navigationIDs);

    let conditionModels = $scope.condition_models = null;

    const changeRecord = {};


    const unbindCurrentPageClicked = $scope.$on('current_page_clicked', function ($event, params) {
        reset(false);
    });
    $scope.$on('$destroy', unbindCurrentPageClicked);

    $scope.handleUncheckRadio = function (modelID) {
        changeRecord[modelID] = true;
    }

    $scope.handleClickStyle = function () {
        $scope.handleUncheckableRadio('style');
        if (conditionModels.style.current_value) {
            if (!conditionModels.colour.current_value && conditionModels.colour.amt_available === 1) {
                const colourChoiceList = conditionModels.colour.choiceList();
                for (let i = 0; i < colourChoiceList.length; i++) {
                    const choice = colourChoiceList[i];
                    if (!choice.hidden) {
                        conditionModels.colour.current_value = choice.id;
                        $scope.handleUncheckRadio("colour");
                        $scope.handleUncheckableRadio("colour");
                        break;
                    }
                }
            }
        } else {
            if (conditionModels.colour.temporarily_hidden && conditionModels.colour.current_value) {
                conditionModels.colour.current_value = null;
                $scope.handleUncheckRadio("colour");
                $scope.handleUncheckableRadio("colour");
            }
        }
    }

    $scope.handleClickColour = function () {
        $scope.handleUncheckableRadio('colour');
        if (conditionModels.colour.current_value) {
            if (!conditionModels.style.current_value && conditionModels.style.amt_available === 1) {
                const styleChoiceList = conditionModels.style.choiceList();
                for (let i = 0; i < styleChoiceList.length; i++) {
                    const choice = styleChoiceList[i];
                    if (!choice.hidden) {
                        conditionModels.style.current_value = choice.id;
                        $scope.handleUncheckRadio("style");
                        $scope.handleUncheckableRadio("style");
                        break;
                    }
                }
            }
        } else {
            if (conditionModels.style.temporarily_hidden && conditionModels.style.current_value) {
                conditionModels.style.current_value = null;
                $scope.handleUncheckRadio("style");
                $scope.handleUncheckableRadio("style");
            }
        }
    }

    $scope.handleUncheckableRadio = function (modelID) {

        const uncheck = !changeRecord[modelID];
        delete changeRecord[modelID];

        const model = conditionModels[modelID];

        if (!model) {
            return;
        }
        if (uncheck) {
            model.current_value = null;
        }

        const conditionModel = conditionModels[modelID];

        let haveSelected = false;
        for (let choiceID in conditionModel.choices) {
            const choice = conditionModel.choices[choiceID];
            choice.selected = !choice.hidden && choiceID === conditionModel.current_value;
            if (choice.selected) {
                haveSelected = true;
            }
        }
        if (!haveSelected) {
            conditionModel.current_value = null;
        }

        $scope.applyCurrentFilter();
    }

    $scope.handleStepRadio = function (stepID, modelID) {

        const conditionModel = conditionModels[modelID];

        if (!conditionModel) {
            return;
        }
        let currentValue = conditionModel.current_value;

        let haveAny = false;
        for (let choiceID in conditionModel.choices) {
            const choice = conditionModel.choices[choiceID];
            choice.selected = !choice.disabled && (currentValue === choiceID || currentValue === "all");
            haveAny = haveAny || choice.selected;
        }
        if (!haveAny && currentValue === "all") {
            conditionModel.current_value = null;
            currentValue = null;
        }

        if (currentValue !== "all") {
            conditionModel.all_selected = false;
        }


        resetFilters(modelID);

        $scope.applyCurrentFilter();
        if (conditionModel.current_value) {
            $scope.showNextStep(stepID);
        }

    }

    $scope.showNextStep = function (stepID) {

        if (!stepID) {
            return;
        }
        let nextStepID = null;
        for (let i = 0; i < $scope.view_model.step_order.length - 1; i++) {
            if ($scope.view_model.step_order[i] === stepID) {
                for (let j = i + 1; j < $scope.view_model.step_order.length; j++) {
                    nextStepID = $scope.view_model.step_order[j];
                    const nextStep = $scope.condition_models[nextStepID];
                    if (nextStep && !nextStep.temporarily_hidden) {
                        break;
                    }
                }
                break;
            }
        }
        if (nextStepID) {
            $scope.view_model.current_step_id = nextStepID;
        }

    }

    $scope.stepNameFor = function (stepID) {
        let index = -1;
        for (let i = 0; i < $scope.view_model.step_order.length - 1; i++) {
            const checkStepID = $scope.view_model.step_order[i];
            const step = $scope.condition_models[checkStepID];
            if (step && !step.temporarily_hidden) {
                index++;
            }
            if (checkStepID === stepID) {
                return "Step " + (index + 1);
            }
        }
        return "";
    }

    function reset(keepValues) {

        if (!keepValues) {
            resetFilters();
        }

        $scope.view_model.current_step_id = $scope.view_model.step_order.length > 0 ? $scope.view_model.step_order[0] : null;
        $scope.applyCurrentFilter();

    }

    function resetFilters(afterFilterID) {
        let canProceed = !afterFilterID;
        for (let i = 0; i < filterModel.filter_order.length; i++) {
            const filterID = filterModel.filter_order[i];
            if (!canProceed) {
                if (filterID === afterFilterID) {
                    canProceed = true;
                }
                continue;
            }

            const conditionModel = conditionModels[filterID];
            conditionModel.current_value = null;

            for (let choiceID in conditionModel.choices) {
                const choice = conditionModel.choices[choiceID];
                if (choice) {
                    choice.disabled = false;
                    choice.filteredBy = {};
                    choice.selected = conditionModel.choice_order.length === 1;
                    if (choice.selected) {
                        conditionModel.current_value = choiceID;
                    }
                }
            }
        }
        if (conditionModels.style.choice_order.length > 1) {
            const selectedChoice = conditionModels.style.current_value ? conditionModels.style.choices[conditionModels.style.current_value] : null;
            if (selectedChoice) {
                selectedChoice.selected = false;
            }
            conditionModels.style.current_value = null;
        }
        if (conditionModels.colour.choice_order.length > 1) {
            const selectedChoice = conditionModels.colour.current_value ? conditionModels.colour.choices[conditionModels.colour.current_value] : null;
            if (selectedChoice) {
                selectedChoice.selected = false;
            }
            conditionModels.colour.current_value = null;
        }
    }

    $scope.applyCurrentFilter = function () {

        let choiceID, choice, styleID, rootColourID, conditionModel;

        let i;

        let styleRootColourIDs = {};
        let rootColourStyleIDs = {};

        if (filterModel.style_root_colour_ids && filterModel.root_colour_style_ids) {
            styleRootColourIDs = siteHelper.simpleCloneObject(filterModel.style_root_colour_ids);
            rootColourStyleIDs = siteHelper.simpleCloneObject(filterModel.root_colour_style_ids);

        } else if (filterModel.pathTypeID && filterModel.condition_models[filterModel.pathTypeID]) {
            //Filter Component Category or Door Type
            conditionModel = filterModel.condition_models[filterModel.pathTypeID];
            conditionModel.amt_available = conditionModel.choice_order.length;
            for (choiceID in conditionModel.choices) {
                choice = conditionModel.choices[choiceID];
                if (choice.selected) {

                    styleRootColourIDs = siteHelper.simpleCloneObject(choice.style_root_colour_ids);
                    rootColourStyleIDs = siteHelper.simpleCloneObject(choice.root_colour_style_ids);

                    break;
                }
            }
        }

        let express24Selected = false;
        let express24Deselected = false;

        const featureChoice = conditionModels.feature && conditionModels.feature.current_value ? conditionModels.feature.choices[conditionModels.feature.current_value] : null;
        const isManufactured = !featureChoice || featureChoice.is_manufactured;
        const styleExpected = !featureChoice || featureChoice.style_expected;
        const overrideStyleName = featureChoice ? featureChoice.overrideStyleName : {};
        $scope.view_model.is_manufactured = isManufactured;

        for (i = 0; i < filterModel.filter_order.length; i++) {
            const filterID = filterModel.filter_order[i];
            if (filterID === "feature" || filterID === "assembly") {
                continue;
            }
            conditionModel = conditionModels[filterID];
            conditionModel.temporarily_hidden = !isManufactured || (filterID === "base_style" && !styleExpected);
            const conditionStyleIDs = {};
            const conditionRootColourIDs = {};

            const validChoices = [];
            const canSelectAll = !!conditionModel.can_select_all;
            let allSelected = canSelectAll;
            let allDisabled = false;

            const unselectedChoices = [];
            const selectedChoices = [];

            let disableWithSelection = null;
            let removeSelections = false;
            if (conditionModel.id === "m2m") {
                if (express24Selected) {
                    disableWithSelection = "m2m_if_no";
                } else if (express24Deselected) {
                    removeSelections = true;
                }
            }

            for (choiceID in conditionModel.choices) {
                choice = conditionModel.choices[choiceID];
                if (!isManufactured || (filterID === "base_style" && !styleExpected)) {
                    choice.selected = true;
                }
                let didDisableWithSelection = false;
                if (choiceID === disableWithSelection) {
                    choice.selected = true;
                    didDisableWithSelection = true;
                } else if (removeSelections || !!disableWithSelection) {
                    choice.selected = false;
                }


                let disabled = true;
                if (conditionModel.is_style_filter) {
                    for (styleID in choice.style_ids) {
                        if (styleRootColourIDs[styleID]) {
                            disabled = false;
                            if (!canSelectAll && selectedChoices.length > 0) {
                                choice.selected = false;
                            }
                            if (choice.selected) {
                                conditionStyleIDs[styleID] = true;
                            }
                        }
                    }
                } else if (conditionModel.is_colour_filter) {
                    for (rootColourID in choice.root_colour_ids) {
                        if (rootColourStyleIDs[rootColourID]) {
                            disabled = false;
                            if (!canSelectAll && selectedChoices.length > 0) {
                                choice.selected = false;
                            }
                            if (choice.selected) {
                                conditionRootColourIDs[rootColourID] = true;
                            }
                        }
                    }
                }
                choice.disabled = disabled;
                if (choice.disabled) {
                    choice.selected = false;
                } else if (!!disableWithSelection) {
                    choice.disabled = true;
                } else {
                    validChoices.push(choice);
                    if (!choice.selected) {
                        allSelected = false;
                        unselectedChoices.push(choice);
                    } else {
                        selectedChoices.push(choice);
                    }
                }
            }
            conditionModel.amt_available = validChoices.length;

            if (selectedChoices.length > 1 && !allSelected) {
                //If there's an unlikely mix up where we have more than 1 choice selected but not all, its simpler just
                //to select every unselected choice
                allSelected = true;
                for (let j = 0; j < unselectedChoices.length; j++) {
                    choice = unselectedChoices[j];
                    choice.selected = true;
                    if (conditionModel.is_style_filter) {
                        for (styleID in choice.style_ids) {
                            if (styleRootColourIDs[styleID]) {
                                conditionStyleIDs[styleID] = true;
                            }
                        }
                    } else if (conditionModel.is_colour_filter) {
                        for (rootColourID in choice.root_colour_ids) {
                            if (rootColourStyleIDs[rootColourID]) {
                                conditionRootColourIDs[rootColourID] = true;
                            }
                        }
                    }
                }
            }

            if (validChoices.length === 0) {
                allSelected = false;
                allDisabled = true;
            } else if (validChoices.length === 1) {
                choice = validChoices[0];
                allSelected = false;
                allDisabled = true;
                if (!choice.selected) {
                    choice.selected = true;
                    selectedChoices.push(choice);
                    for (let j = 0; j < unselectedChoices.length; j++) {
                        if (unselectedChoices[j] === choice) {
                            unselectedChoices.splice(j, 1);
                            break;
                        }
                    }
                    if (conditionModel.is_style_filter) {
                        for (styleID in choice.style_ids) {
                            if (styleRootColourIDs[styleID]) {
                                conditionStyleIDs[styleID] = true;
                            }
                        }
                    } else if (conditionModel.is_colour_filter) {
                        for (rootColourID in choice.root_colour_ids) {
                            if (rootColourStyleIDs[rootColourID]) {
                                conditionRootColourIDs[rootColourID] = true;
                            }
                        }
                    }
                }
            }
            conditionModel.all_selected = allSelected;
            conditionModel.all_disabled = allDisabled;

            if (disableWithSelection) {
                conditionModel.current_value = disableWithSelection;
            } else if (allSelected) {
                conditionModel.current_value = "all";
            } else if (selectedChoices.length > 0) {
                conditionModel.current_value = selectedChoices[0].id;
            } else {
                conditionModel.current_value = null;
            }

            if (!conditionModel.hidden) {
                if (conditionModel.is_style_filter) {
                    for (styleID in styleRootColourIDs) {
                        if (conditionStyleIDs[styleID]) {
                            for (rootColourID in styleRootColourIDs[styleID]) {
                                conditionRootColourIDs[rootColourID] = true;
                            }
                        } else {
                            delete styleRootColourIDs[styleID];
                        }
                    }
                    for (rootColourID in rootColourStyleIDs) {
                        if (!conditionRootColourIDs[rootColourID]) {
                            delete rootColourStyleIDs[rootColourID];
                        }
                    }
                } else if (conditionModel.is_colour_filter) {
                    for (rootColourID in rootColourStyleIDs) {
                        if (conditionRootColourIDs[rootColourID]) {
                            for (styleID in rootColourStyleIDs[rootColourID]) {
                                conditionStyleIDs[styleID] = true;
                            }
                        } else {
                            delete rootColourStyleIDs[rootColourID];
                        }
                    }
                    for (styleID in styleRootColourIDs) {
                        if (!conditionStyleIDs[styleID]) {
                            delete styleRootColourIDs[styleID];
                        }
                    }
                }
            }
            if (conditionModel.id === "express_24") {
                express24Selected = conditionModel.current_value === "express_24_if_yes";
                express24Deselected = !express24Selected && conditionModel.previousValue === "express_24_if_yes";
            }
        }


        let haveBasicInput = true;
        for (i = filterModel.filter_order.length - 1; i >= 0; i--) {
            const filterID = filterModel.filter_order[i];
            conditionModel = conditionModels[filterID];
            if (!conditionModel.hidden) {
                haveBasicInput = false;
                for (choiceID in conditionModel.choices) {
                    choice = conditionModel.choices[choiceID];
                    if (choice.selected) {
                        haveBasicInput = true;
                        break;
                    }
                }
                break;
            }
        }


        let styleCount = 0;
        let colourCount = 0;

        let selectedStyleID = null;
        let selectedColourID = null;

        for (choiceID in conditionModels.style.choices) {
            choice = conditionModels.style.choices[choiceID];
            if (overrideStyleName[choice.id]) {
                choice.dislay_name = overrideStyleName[choice.id];
            } else {
                choice.dislay_name = null;
            }
            choice.hidden = !styleRootColourIDs[choiceID];
            if (!choice.hidden) {
                styleCount++;
            }
            if (choice.hidden || selectedStyleID) {
                choice.selected = false;
            }
            if (choice.selected) {
                selectedStyleID = choiceID;
            }
        }


        conditionModels.style.temporarily_hidden = false;
        if ((!isManufactured || !styleExpected) && styleCount === 1) {
            conditionModels.style.temporarily_hidden = true;
            if (!selectedStyleID) {
                for (choiceID in conditionModels.style.choices) {
                    choice = conditionModels.style.choices[choiceID];
                    if (!choice.hidden) {
                        choice.selected = true;
                        selectedStyleID = choiceID;
                        break;
                    }
                }
            }
        }

        let styleColourCount = 0;

        for (choiceID in conditionModels.colour.choices) {
            choice = conditionModels.colour.choices[choiceID];
            choice.hidden = !rootColourStyleIDs[choiceID];
            if (!choice.hidden) {
                colourCount++;
            }
            if (choice.hidden || selectedColourID) {
                choice.selected = false;
            }
            const fromSelectedStyle = !!selectedStyleID && !!styleRootColourIDs[selectedStyleID][choiceID];
            if (fromSelectedStyle) {
                styleColourCount = 1;
            }

            if (selectedStyleID && !fromSelectedStyle) {
                choice.selected = false;
            } else if (choice.selected) {
                selectedColourID = choiceID;
            }
        }

        conditionModels.colour.temporarily_hidden = false;
        if (!isManufactured && styleColourCount < 2) {
            conditionModels.colour.temporarily_hidden = true;
            if (selectedStyleID && !selectedColourID) {
                for (choiceID in conditionModels.colour.choices) {
                    choice = conditionModels.colour.choices[choiceID];
                    const fromSelectedStyle = !!styleRootColourIDs[selectedStyleID][choiceID];
                    if (fromSelectedStyle) {
                        choice.selected = true;
                        selectedColourID = choiceID;
                        break;
                    }
                }
            }
        }


        $scope.view_model.have_basic_input = haveBasicInput
        $scope.view_model.can_show_result = haveBasicInput && (styleCount > 0 || conditionModels.style.hidden) && (colourCount > 0 || conditionModels.colour.hidden);
        conditionModels.style.current_value = selectedStyleID;
        conditionModels.colour.current_value = selectedColourID;

        for (let key in conditionModels) {
            conditionModel = conditionModels[key];
            conditionModel.previousValue = conditionModel.current_value;
        }


        let reapplyStyle = false;
        let reapplyColour = false;

        if (selectedStyleID) {
            for (rootColourID in rootColourStyleIDs) {
                if (!styleRootColourIDs[selectedStyleID][rootColourID]) {
                    reapplyColour = true;
                    delete rootColourStyleIDs[rootColourID];
                }
            }
        }

        if (selectedColourID) {
            for (styleID in styleRootColourIDs) {
                if (!rootColourStyleIDs[selectedColourID][styleID]) {
                    reapplyStyle = true;
                    delete styleRootColourIDs[styleID];
                }
            }
        }

        if (reapplyStyle) {
            styleCount = 0;

            for (choiceID in conditionModels.style.choices) {
                choice = conditionModels.style.choices[choiceID];
                choice.hidden = !styleRootColourIDs[choiceID];
                if (!choice.hidden) {
                    styleCount++;
                }
            }
        }

        if (reapplyColour) {
            colourCount = 0;

            for (choiceID in conditionModels.colour.choices) {
                choice = conditionModels.colour.choices[choiceID];
                choice.hidden = !rootColourStyleIDs[choiceID];
                if (!choice.hidden) {
                    colourCount++;
                }
            }
        }


        $scope.condition_models.style.amt_available = styleCount;
        $scope.condition_models.colour.amt_available = colourCount;

        $scope.view_model.can_use_result = $scope.view_model.can_show_result && (styleCount > 0 || conditionModels.style.hidden) && (colourCount > 0 || conditionModels.colour.hidden);
        $scope.view_model.can_select_result = $scope.view_model.can_use_result && (selectedStyleID || conditionModels.style.hidden) && (selectedColourID || conditionModels.colour.hidden);

        for (let siteRangeID in conditionModels.site_range.choices) {
            choice = conditionModels.site_range.choices[siteRangeID];
            let hidden = true;
            for (i = 0; i < choice.colour_list.length; i++) {
                if (!choice.colour_list[i].hidden) {
                    hidden = false;
                    break;
                }
            }
            choice.hidden = hidden;
        }
    }

    $scope.style_choice = function (styleID) {
        return conditionModels.style.choices[styleID];
    }

    $scope.colour_choice = function (rootColourID) {
        return conditionModels.colour.choices[rootColourID];
    }

    $scope.finalImgSrcClass = function () {
        const imgSrc = $scope.finalImgSrc(true);
        return imgSrc ? "local-image" : "remote-image"
    }

    $scope.finalImgSrc = function (localOnly) {
        const styleID = conditionModels.style.current_value;
        const rootColourID = conditionModels.colour.current_value;
        const styleChoice = styleID ? $scope.style_choice(styleID) : null;
        const colourChoice = rootColourID ? $scope.colour_choice(rootColourID) : null;
        if (!styleChoice && !colourChoice) {
            return null;
        }
        const primaryChoice = colourChoice ? colourChoice : styleChoice;
        const siteRangeID = primaryChoice.site_range_id;
        const siteRangeChoice = siteRangeID ? conditionModels.site_range.choices[siteRangeID] : null;
        const defaultColourID = siteRangeChoice ? siteRangeChoice.default_colour_id : null
        const colourID = colourChoice ? colourChoice.id : defaultColourID;

        if (!colourID) {
            return "";
        }

        if (localOnly) {

            let imgSrc = $rootScope.service.image.getLocalStyleImgSrc(siteRangeID, colourID, styleID);
            if (imgSrc) {
                return imgSrc;
            }
            const requestRangeID = $rootScope.service.site_range.getRequestRangeID(siteRangeID);
            if (requestRangeID !== "pronto" && requestRangeID !== "bella") {
                imgSrc = $rootScope.service.image.getLocalColourImgSrc(siteRangeID, colourID);
                if (imgSrc) {
                    return imgSrc;
                }
            }
            return null;
        }

        const imageTypeID = siteRangeID === "bella" ? "style" : "colour";

        return $rootScope.service.image.determineImgSrc({
            image_type_id: imageTypeID,
            site_range_id: siteRangeID,
            colour_id: colourID,
            style_id: styleID
        });
    }


    $scope.finalOverlay = function () {
        const colourValue = conditionModels.colour.current_value;
        const colourChoice = colourValue ? $scope.colour_choice(colourValue) : null;
        if (colourChoice) {
            if (colourChoice.limited_stock) {
                return "limited_stock";
            }
            if (colourChoice.promote_new) {
                return "promote_new";
            }
            if (colourChoice.coming_soon) {
                return "coming_soon";
            }
            if (colourChoice.back_soon) {
                return "back_soon";
            }
        }
        const styleValue = conditionModels.style.current_value;
        const styleChoice = styleValue ? $scope.style_choice(styleValue) : null;
        if (styleChoice) {
            if (styleChoice.limited_stock) {
                return "limited_stock";
            }
            if (styleChoice.promote_new) {
                return "promote_new";
            }
            if (styleChoice.coming_soon) {
                return "coming_soon";
            }
            if (styleChoice.back_soon) {
                return "back_soon";
            }
        }
        return "";
    }

    $scope.finalStyleName = function () {
        const styleValue = conditionModels.style.current_value;
        const styleChoice = styleValue ? $scope.style_choice(styleValue) : null;
        return styleChoice ? (styleChoice.dislay_name ? styleChoice.dislay_name : styleChoice.name) : "";
    }

    $scope.finalColourName = function () {
        const colourValue = conditionModels.colour.current_value;
        const colourChoice = colourValue ? $scope.colour_choice(colourValue) : null;
        return colourChoice ? colourChoice.name : "";
    }

    $scope.finalImgName = function () {
        const styleName = $scope.finalStyleName();
        const colourName = $scope.finalColourName();
        if (!styleName && !colourName) {
            return ""
        }
        if (styleName && colourName) {
            return styleName + " - " + colourName;
        }
        if (styleName) {
            return styleName
        }
        return colourName;
    }

    $scope.buttonTxt = function () {
        return "Select Product";
    }

    $scope.hasWarning = function () {
        let previousStep = null;
        let currentStep = null;
        let nextStep = null;

        for (let i = 0; i < $scope.view_model.step_order.length; i++) {
            const stepID = $scope.view_model.step_order[i];
            const step = $scope.view_model.steps[stepID];
            if (currentStep) {
                nextStep = step;
                break;
            }
            if (stepID === $scope.view_model.current_step_id) {
                currentStep = step;
                continue;
            }
            previousStep = step;
        }

        if (!currentStep) {
            return false;
        }

        let previousModelID = previousStep ? previousStep.model_id : null;
        const currentModelID = currentStep.model_id;
        let nextModelID = nextStep ? nextStep.model_id : null;

        let isPreviousStep = false;
        let isCurrentStep = false;
        for (let i = 0; i < filterModel.filter_order.length; i++) {
            const conditionModel = conditionModels[filterModel.filter_order[i]];
            if (conditionModel && !conditionModel.hidden) {
                if (conditionModel.id === previousModelID) {
                    isPreviousStep = true;
                    continue;
                }
                if (conditionModel.id === currentModelID) {
                    isPreviousStep = false;
                    isCurrentStep = true;
                    continue;
                }
                if (conditionModel.id === nextModelID) {
                    break;
                }
                if (isPreviousStep) {
                    previousModelID = conditionModel.id;
                } else if (isCurrentStep) {
                    if (!conditionModel.current_value) {
                        nextModelID = conditionModel.id;
                        nextStep = currentStep;
                        break;
                    }
                }
            }
        }

        const previousModel = previousStep && previousStep.model_id ? conditionModels[previousModelID] : null;
        const currentModel = currentStep && currentStep.model_id ? conditionModels[currentModelID] : null;
        const nextModel = nextStep && nextStep.model_id ? conditionModels[nextModelID] : null;

        if (previousModel) {
            if (!previousModel.current_value) {
                return "You must " + previousStep.mustChoosePrevious + " before your can select a " + currentStep.simpleName.toLowerCase() + ".";
            }
        }

        if (nextStep) {
            if (nextModel) {
                if (currentModel.current_value && nextModel.amt_available === 0) {
                    return "There are no " + nextStep.pluralName.toLowerCase() + " that match your choices. You should apply some different filters.";
                }
            }
        } else if (currentStep.current_value && !$scope.view_model.can_show_result) {
            return "There are no products that match your choices. You should apply some different filters.";
        }

        return false;
    }

    $scope.productHref = function () {

        if (!$scope.view_model.can_select_result) {
            return null;
        }

        const rootColourID = conditionModels.colour.current_value ? conditionModels.colour.current_value : (conditionModels.colour.choice_order.length === 1 ? conditionModels.colour.choice_order[0] : null);

        const colourChoice = $scope.colour_choice(rootColourID);

        let routeNavigationIDs = {
            site_range_id: colourChoice ? colourChoice.site_range_id : null,
            colour_id: colourChoice ? colourChoice.id : null,
            style_id: conditionModels.style.current_value
        }

        if (conditionModels.feature.navigation_pointer) {
            routeNavigationIDs[conditionModels.feature.navigation_pointer] = conditionModels.feature.current_value;
        }
        if (!conditionModels.assembly.hidden) {
            routeNavigationIDs.assembly_id = conditionModels.assembly.current_value;
        }


        routeNavigationIDs = siteHelper.simpleCloneObject(routeNavigationIDs, navigationIDs, true);

        return $rootScope.navigation_manager.createNavigationModel(null, routeNavigationIDs, true).href;

    }

    $scope.stepCurrentChoiceName = function (stepID) {

        const step = $scope.view_model.steps[stepID];
        const conditionModel = step && step.model_id ? conditionModels[step.model_id] : null;
        if (!conditionModel || !conditionModel.current_value) {
            return null;
        }
        if (conditionModel.current_value === "all") {
            return "All";
        }
        const choice = conditionModel.choices[conditionModel.current_value];
        return choice ? choice.name : null;
    }

    $scope.view_model = {
        current_step_id: null,
        step_order: [],
        steps: {},
        have_data: false,
        have_basic_input: false,
        can_show_result: false,
        can_use_result: false,
        can_select_result: false,
        style_count: 0,
        colour_count: 0,
        is_manufactured: false
    }

    $scope.filter_functions = {
        doesModelRequireStep: function (conditionModel) {
            return true
        },
        onStepsCreated: null
    }

    function createSteps() {
        let i, conditionModel;
        $scope.view_model.step_order = [];
        $scope.view_model.steps = {};
        const validModels = [];

        for (i = 0; i < filterModel.filter_order.length; i++) {
            conditionModel = conditionModels[filterModel.filter_order[i]];
            if (conditionModel && !conditionModel.hidden && $scope.filter_functions.doesModelRequireStep(conditionModel)) {
                validModels.push(conditionModel);
            }
        }
        for (i = 0; i < validModels.length; i++) {
            conditionModel = validModels[i];
            let simpleName = conditionModel.name;
            let pluralName = "Selections";
            let callPreviousAStep = false;
            let isAn = false;
            switch (conditionModel.id) {
                case "feature":
                    pluralName = "Products";
                    break;
                case "assembly":
                    pluralName = "Assemblies";
                    isAn = true;
                    break;
                case "express_24":
                    callPreviousAStep = true;
                    break;
                case "manufacturing_process":
                    pluralName = "Specifications";
                    break;
                case "base_style":
                    pluralName = "Styles";
                    simpleName = "Style";
                    break;
                case "base_colour":
                    pluralName = "Colours";
                    simpleName = "Colour";
                    break;
                case "finish":
                    pluralName = "Finishes";
                    break;
                default:
                    break;
            }

            const mustChoosePrevious = callPreviousAStep ? "complete step " + (i + 1) : "choose " + (!isAn ? "a" : "an") + " " + simpleName.toLowerCase();

            $scope.view_model.steps[conditionModel.id] = {
                id: conditionModel.id,
                model_id: conditionModel.id,
                can_select_all: !!conditionModel.can_select_all,
                list_name: conditionModel.name,
                simpleName: simpleName,
                mustChoosePrevious: mustChoosePrevious,
                page_name: "Select " + (!isAn ? "a" : "an") + " " + simpleName,
                step_name: validModels.length > 1 ? "Step " + (i + 1) : "",
                pluralName: pluralName
            }
            $scope.view_model.step_order.push(conditionModel.id);
        }
        if ($scope.filter_functions.onStepsCreated) {
            $scope.filter_functions.onStepsCreated()
        }
    }

    $scope.populateFilter = function () {
        const modelInitialized = filterModel.initialized;

        if (!modelInitialized) {
            filterModel.initFilter()
        }
        conditionModels = $scope.condition_models = filterModel.condition_models;
        createSteps();
        reset(modelInitialized);

        $scope.view_model.have_data = true;
    }

    if (!$scope.hasChildFilterController) {
        $scope.populateFilter();
    }

}])